export default __webpack_public_path__ + "static/media/easylease.f7cf028a.svg";